import { Route, Routes } from 'react-router-dom';

import CouponPage from './coupon';
import CouponsMain from './main';

export default function CouponsPage() {
  return (
    <Routes>
      <Route path="" element={<CouponsMain />} />
      <Route path=":coupon_id/*" element={<CouponPage />} />
    </Routes>
  );
}
